import React from "react";

// Horizontal arrows that flank the "Lowest Payment … Highest Payment" label in
// Best-Payment sort mode (stroke inherits the header's accent-blue color).
const ArrowLeft = () => (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" stroke="currentColor"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="7" x2="2" y2="7"/>
        <polyline points="8 1 2 7 8 13"/>
    </svg>
)
const ArrowRight = () => (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" stroke="currentColor"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="2" y1="7" x2="18" y2="7"/>
        <polyline points="12 1 18 7 12 13"/>
    </svg>
)

export const DeskingTableHeaders = ( { lenders, hasTiers, sortByBestPayment, maxColumns } ) => {

    return (
        <thead>
            <tr>
                <th className={'term th-term'}>Term</th>
                {
                    hasTiers &&
                    <th className={'tier th-tier'}>Tier</th>
                }
                {
                    // Best Payment mode: columns are ranks (cheapest → highest),
                    // not lenders — so a single header spans them all with the
                    // "Lowest Payment | Highest Payment" axis label and arrows.
                    sortByBestPayment
                        ? <th className={'th-lender th-best-payment'} colSpan={Math.max(maxColumns, 1)}>
                            <span className={'bp-sort-label'}>
                                <ArrowLeft/>
                                Lowest Payment
                                <span className={'bp-sort-divider'}>|</span>
                                Highest Payment
                                <ArrowRight/>
                            </span>
                          </th>
                        : lenders.map((lender, idx) => <th key={idx} className={'th-lender'}>{lender}</th>)
                }
            </tr>
        </thead>
    )
}
